import { ApiService, CliaCertificate } from "pwapi";

import { CliaCertificateOption } from "../edit/ResourceOptions";
import SelectSearchInput from "../edit/SelectSearchInput";

const mapCertsToOptions = (certs: CliaCertificate[]) => {
  return [
    {
      value: "",
      label: "All TC CLIAs",
      object: { name: "All TC CLIA Certificates" },
    },
    ...certs
      .filter((cert) => cert.id && cert.name && cert.number)
      .map((cert) => ({
        value: `${cert.name} - ${cert.number},${cert.id}`,
        label: cert.name,
        object: cert,
      })),
  ];
};

const TCCliaCertificateFilter = ({
  onChange,
  value,
  label = "TC CLIA Certificate",
}: {
  onChange: Function;
  value?: string;
  label?: string;
}) => {
  const content = value?.match(/(.*),(\d*)$/)?.[1] || undefined;

  return (
    <SelectSearchInput
      label={label}
      field="grossedByCert"
      filter="name"
      onChange={onChange}
      serviceOptions={{
        hasLabId: true,
      }}
      mapToOptions={mapCertsToOptions}
      apiService={ApiService.listCliaCertificates}
      component={CliaCertificateOption}
    >
      {content ? content : "All TC CLIA Certficates"}
    </SelectSearchInput>
  );
};

export default TCCliaCertificateFilter;
